import { StyleSheet } from 'react-native';

import { Fonts, Colors } from '../../Themes';

export default StyleSheet.create({
  itemContainer: theme => ({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 3.5,
    width: 42,
    height: 42,
    borderRadius: 21,
    backgroundColor: theme.colors.filterBarItemColor,
  }),
  selectedItemContainer: {
    backgroundColor: Colors.ocean,
  },
  item: {
    textAlign: 'center',
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    lineHeight: 20,
    paddingVertical: 12,
  },
  selectedItem: theme => ({
    color: theme.colors.activeColorTwo,
  }),
});
